import styled from "styled-components";
import { Checkbox } from "@mui/material";

import { SPACING } from "../../../../utils/constants";

export const AppliedCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  padding: ${SPACING.md}px;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  background: var(--color-background-2);
`;

export const AppliedHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
`;

export const AppliedLabel = styled.span`
  font-size: var(--text-xs);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--color-text-secondary);
`;

export const ManualToggle = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs}px;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
  cursor: pointer;
`;

export const ManualCheckbox = styled(Checkbox)`
  && {
    padding: 0;
    color: var(--color-text-secondary);
  }

  &&.Mui-checked {
    color: var(--color-primary);
  }
`;

export const SplitBar = styled.div`
  display: flex;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background-color: var(--color-border);
`;

export const SplitPrincipal = styled.div<{ $pct: number }>`
  width: ${({ $pct }) => `${$pct}%`};
  background-color: var(--color-primary);
`;

export const SplitLegend = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACING.md}px;
`;

export const LegendItem = styled.div<{ $align?: "start" | "end" }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  align-items: ${({ $align }) =>
    $align === "end" ? "flex-end" : "flex-start"};
  text-align: ${({ $align }) => ($align === "end" ? "right" : "left")};
`;

export const LegendHead = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const LegendSwatch = styled.span<{ $kind: "principal" | "interest" }>`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 3px;
  background-color: ${({ $kind }) =>
    $kind === "principal" ? "var(--color-primary)" : "var(--color-border)"};
`;

export const LegendValue = styled.span<{ $kind: "principal" | "interest" }>`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-lg);
  font-weight: 700;
  color: ${({ $kind }) =>
    $kind === "principal"
      ? "var(--color-primary)"
      : "var(--color-text-default)"};
`;

export const Divider = styled.hr`
  margin: 0;
  border: none;
  border-top: 1px solid var(--color-border);
`;

export const BalanceRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${SPACING.md}px;
`;

export const BalanceLabel = styled.span`
  font-size: var(--text-base);
  color: var(--color-text-secondary);
`;

export const BalanceValue = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-md);
  font-weight: 700;
  color: var(--color-text-default);
`;
